export const getSalesIdCandidates = (customerData, customerTpid) => {
    const normalizedTpid = customerTpid.trim();
    const candidates = (Array.isArray(customerData) ? customerData : [])
        .filter((customer) => { var _a; return ((_a = customer.tpid) === null || _a === void 0 ? void 0 : _a.trim()) === normalizedTpid; })
        .map((customer) => { var _a; return (_a = customer.msSalesID) === null || _a === void 0 ? void 0 : _a.trim(); })
        .filter((salesId) => !!salesId && salesId !== "0");
    return Array.from(new Set(candidates)).sort((left, right) => left.localeCompare(right));
};
